const partnerLogos = [
  [
    {
      logo: '/assets/partner-logos/aws-logo.png'
    },
    {
      logo: '/assets/partner-logos/canva.png'
    },
    {
      logo: '/assets/partner-logos/notion.png'
    },
    {
      logo: '/assets/partner-logos/razorpay-logo.png'
    },
    {
      logo: '/assets/partner-logos/zoho.jpg'
    },
    {
      logo: '/assets/partner-logos/we-work-labs.png'
    },
    {
      logo: '/assets/partner-logos/microsoft-azure-logo.png'
    },
    {
      logo: '/assets/partner-logos/freshworks-logo.png'
    },
    {
      logo: '/assets/partner-logos/google-cloud-logo.png'
    }
  ],
  [
    {
      logo: '/assets/partner-logos/math-works.png'
    },
    {
      logo: '/assets/partner-logos/hubspot-logo.png'
    },
    {
      logo: '/assets/partner-logos/plum.png'
    },
    {
      logo: '/assets/partner-logos/qapita-logo.png'
    },
    {
      logo: '/assets/partner-logos/disney-hotstar-logo.png'
    },
    {
      logo: '/assets/partner-logos/manah-logo.png'
    },
    {
      logo: '/assets/partner-logos/paytm-logo.png'
    },
    {
      logo: '/assets/partner-logos/heelium.png'
    },
    {
      logo: '/assets/partner-logos/cashfree.png'
    }
  ],
  [
    {
      logo: '/assets/partner-logos/onsurity.png'
    },
    {
      logo: '/assets/partner-logos/twilio.png'
    },
    {
      logo: '/assets/partner-logos/stripe.png'
    },
    {
      logo: '/assets/partner-logos/mtalkz.png'
    },
    {
      logo: '/assets/partner-logos/veri5-digital.png'
    },
    {
      logo: '/assets/partner-logos/zaakpay.png'
    },
    {
      logo: '/assets/partner-logos/payu.png'
    },
    {
      logo: '/assets/partner-logos/signzy.png'
    },
    {
      logo: '/assets/partner-logos/exotel.png'
    }
  ]
];

export default partnerLogos;
